import * as fromDatatype from '../datatype-library';

export interface bl_wf_md_transition_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  process_guid: fromDatatype.GuidDataFieldInterface;
  current_process_status_guid: fromDatatype.GuidDataFieldInterface;
  next_process_status_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wf_md_transition_RowClass
  implements bl_wf_md_transition_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    process_guid: fromDatatype.GuidDataFieldInterface;
    current_process_status_guid: fromDatatype.GuidDataFieldInterface;
    next_process_status_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
}
